import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';

export function playerFactory() {
  return player;
}

export const provideLottie = () =>
  provideLottieOptions({
    player: playerFactory,
  });
